import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { agentV2Request } from '@/agent-v2/conversations/fetch/agent-v2-request'

/**
 * POST: Initialize a Conversation With the Matter's Medical Chronology Asset
 * The seeded turn is complete by the time this resolves, so callers can
 * navigate/fetch the conversation detail immediately after this call succeeds.
 */
export async function postInitAgentV2ConversationWithMedChronAsset(conversationId: string, assetId: string): Promise<void> {
  return agentV2Request({
    url: `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}/initialize-with-med-chron-asset`,
    method: 'POST',
    body: JSON.stringify({ asset_id: assetId }),
    sentryEndpoint: 'POST /api/v2/agent/conversations/{conversation_id}/initialize-with-med-chron-asset',
    allowNoContent: true,
    parseResponse: () => undefined,
  })
}
